import React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import Bold from 'components/Bold';
import { WorksheetPageIndex } from 'services/worksheet/types';
import {
    EquipmentSetName,
    EquipmentSetTankVolume
} from 'services/equipmentSets/types';
import {
    makeSelectSprayWorksheetEquipmentSetName,
    makeSelectSprayWorksheetEquipmentSetTankVolume
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    name: EquipmentSetName;
    tankVolume: EquipmentSetTankVolume;
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetEquipmentSetComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { name, tankVolume } = this.props;

        return (
            <div className="print-worksheet-page-section">
                <Grid columns="2">
                    <GridRow>
                        <GridColumn width="12">
                            <Bold>Equipment set:</Bold> <span>{name}</span>
                        </GridColumn>
                        <GridColumn textAlign="right" width="4">
                            <Bold>Tank volume:</Bold>{' '}
                            <span>{`${tankVolume}L`}</span>
                        </GridColumn>
                    </GridRow>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectSprayWorksheetEquipmentSetName(),
    tankVolume: makeSelectSprayWorksheetEquipmentSetTankVolume()
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetEquipmentSetComponent
);
